import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import AirportPickupBasicRateDrawer from "components/drawer/AirportPickupBasicRateDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ShowHideButton from "components/table/ShowHideButton";

const AirportPickupBasicRateTable = ({
  airportPickupBasicRate,
  perpage,
  currentPage,
  hideEdit,
  hideDelete,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  const airportPickupBasicRatesorted = airportPickupBasicRate.sort((a, b) =>
    a.name_of_airport.localeCompare(b.name_of_airport)
  );
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <AirportPickupBasicRateDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {airportPickupBasicRatesorted?.slice(0, perpage).map((data, index) => (
          <React.Fragment key={data.id}>
            {data["vehicle_type_id"].map((item, vehicleIndex) => (
              <TableRow key={`${data.id}-${vehicleIndex}`}>
                {vehicleIndex === 0 && (
                  <>
                    <TableCell
                      rowSpan={data["vehicle_type_id"].length}
                      className="text-sm text-center"
                    >
                      {(currentPage - 1) * perpage + index + 1}
                    </TableCell>
                    <TableCell
                      rowSpan={data["vehicle_type_id"].length}
                      className="text-sm text-center"
                    >
                      {data["name_of_airport"]}
                    </TableCell>
                  </>
                )}

                <TableCell className="text-sm text-center">
                  {data["vehicle_type_names"][item]}
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data["min_rate"][item]}
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data["min_km"][item]}
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data["extra_km"][item]}
                </TableCell>

                <TableCell className="text-sm text-center">
                  {data["prime"][item] + "%"}
                </TableCell>

                
                  {vehicleIndex === 0 && (
                    <TableCell
                  className="text-sm text-center"
                  rowSpan={data["vehicle_type_id"].length}
                >
                    <ShowHideButton
                      id={data.id}
                      status={data.is_active}
                      Loading={true}
                    />
                     </TableCell>
                  )}
               

                {vehicleIndex === 0 && (
                  <TableCell
                    rowSpan={data["vehicle_type_id"].length}
                    className="text-center"
                  >
                    <EditDeleteButton
                      title={data["Airport Pickup"]}
                      id={data.id}
                      handleUpdate={handleUpdate}
                      handleModalOpen={handleModalOpen}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </React.Fragment>
        ))}
      </TableBody>
    </>
  );
};

export default AirportPickupBasicRateTable;
